import React, { useEffect, useRef, useState, useCallback } from 'react';
import ToggleButtons from '../../components/Shared/ToggleButtons/ToggleButtons';
import QuillInput from '../../components/Shared/QuillInput/QuillInput';
import { showSuccessToast } from '../../components/Shared/Toastify/toastHelper';
import { useWebSettings } from '../../context/WebSettingsContext';

const label = [
  { label_name: "English", index: 0 },
  { label_name: "French", index: 1 },
  { label_name: "Arabic", index: 2 }
];

function Description() {
  const [activeButton, setActiveButton] = useState(0);
  const { webSettings, updateWebSettings, loading } = useWebSettings();
  console.log(webSettings);
  const [localTitles, setLocalTitles] = useState({
    eng: '',
    fr: '',
    ar: ''
  });
  const [localDescriptions, setLocalDescriptions] = useState({
    eng: '',
    fr: '',
    ar: ''
  });
  
  // Update local state when webSettings changes
  useEffect(() => {
    if (!loading && webSettings) {
      setLocalTitles(webSettings.description.title);
      setLocalDescriptions(webSettings.description.body);
    }
  }, [webSettings, loading]);

  const handleSetActiveButton = (value: number) => {
    setActiveButton(value);
  };

  const handleDescriptionChange = useCallback((value: string) => {
    const language = activeButton === 0 ? 'eng' : activeButton === 1 ? 'fr' : 'ar';
    setLocalDescriptions(prev => ({
      ...prev,
      [language]: value
    }));
  }, [activeButton]);

  const handleTitleChange = useCallback((e: React.ChangeEvent<HTMLInputElement>) => {
    const language = activeButton === 0 ? 'eng' : activeButton === 1 ? 'fr' : 'ar';
    const newValue = e.target.value;
    setLocalTitles(prev => ({
      ...prev,
      [language]: newValue
    }));
  }, [activeButton]);

  const handleSave = async () => {
    try {
      await updateWebSettings({
        description: {
          title: localTitles,
          body: localDescriptions
        }
      });
      showSuccessToast('Settings updated successfully');
    } catch (error) {
      console.error('Error updating settings:', error);
    }
  };

  if (loading) {
    return <div>Loading...</div>;
  }

  const getCurrentDescription = () => {
    switch (activeButton) {
      case 0:
        return localDescriptions.eng;
      case 1:
        return localDescriptions.fr;
      case 2:
        return localDescriptions.ar;
      default:
        return '';
    }
  };

  const getCurrentTitle = () => {
    switch (activeButton) {
      case 0:
        return localTitles.eng;
      case 1:
        return localTitles.fr;
      case 2:
        return localTitles.ar;
      default:
        return '';
    }
  };

  return (
    <div className='flex flex-col'>
      <ToggleButtons
        labels={label}
        activeButton={activeButton}
        setActiveButton={handleSetActiveButton}
      />

      <div className='my-[40px] bg-white rounded-[16px] pb-[32px] pt-[16px] px-[24px] flex flex-col gap-[32px]'>
        <p className='font-semibold text-[20px]'>Section Title</p>
        <div>
          <label htmlFor='Title'>Title</label>
          <input
            type="text"
            id="Title"
            className='w-full border border-[#E0E0E0] rounded-[8px] px-[16px] py-[8px] mt-[4px]'
            placeholder='Enter Section Title'
            value={getCurrentTitle()}
            onChange={handleTitleChange}
          />
        </div>
      </div>

      <QuillInput 
        key={`quill-${activeButton}`}
        title='Description Details' 
        value={getCurrentDescription()}
        onChange={handleDescriptionChange}
      />

      <button 
        className='mt-[40px] ml-auto bg-[#00726B] rounded-[8px] h-[48px] w-[140px] text-[14px] font-medium text-white'
        onClick={handleSave}
      >
        SAVE
      </button>
    </div>
  );
}

export default Description;
